// Define constants for colors and sizes
export const COLORS = {
  spinner: '#737373',
  primary: '#FF9C21',
  secondary: '#0E0E0E',
  background: '#FDFCF9',
  error: '#DB3737',
  divider: '#E1E8ED',
  buttonBg: '#012E32',
  buttonText: 'white',
  secondaryText: '#737373',
  success: '#0F9960',
  outerBackground: '#FFF1F1',

  // Node border colors
  selectedBorder: '4px solid #F4C671',
  unselectedBorder: '1px solid #E1E8ED',

  // Node background colors
  nodeError: '#FFF1F1',
  nodeSuccess: '#ECFAF4',
  nodeInProgress: '#FDF7ED',
  nodeInitializing: '#FDF7ED',
  nodeNone: 'white',
};
export const SIZES = {
  iconSmall: '12px',
  iconMedium: '16px',
  textSmall: '14px',
  textMedium: '16px',
  gapSmall: 2,
  gapMedium: 8,
  gapLarge: 16,
  padding: 4,
  borderRadius: 8,
  buttonHeight: '38px',
  componentHeight: '70px',
  outerPadding: 1, // Padding for the outer wrapper
  nodeHandleWidth: 12,
  nodeHandleHeight: 12,
};
